import { useState } from "react";
import { Row, Col } from "react-bootstrap"
import axiosService from "../../../utils/axios.service";
import "../scss/report.scss"
import { Table, Button } from 'antd';
import 'antd/dist/antd.min.css'
import StorageService from "../../../utils/storage.service";
import Loading from "../../customer/Loading";
import { Tooltip } from "antd";

const ReportKtvTvvDetailCat = (props) => {
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)
     
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const columns = [
        { dataIndex: 'users_name', title: 'Nhân viên', width: 150  , fixed:'left'},
        {
            dataIndex: 'total_price',
            title: <Tooltip className="show-tooltip" title='Tổng tiền khách hàng phải thanh toán cho hoá đơn kỹ thuật viên đã tư vấn cho khách hàng trong khoảng thơi gian đã chọn. Không quan tâm khách đã thanh toán hay chưa. Nhận những đơn upsale, chuyển đổi cọc, hoàn thành, nâng cấp. Không nhận đơn nạp tiền.'> Doanh số thuần <i className="fas fa-info-circle"></i></Tooltip>,

            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{convertCurrency(data)}</p>
                )
            },
        },
        {
            dataIndex: 'total_paid',
            title: <Tooltip className="show-tooltip" title='Tổng tiền nhân viên nhận được khi khách hàng thanh toán hoá đơn nhân viên đã tư vấn bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy.'> Tổng thực thu bán hàng <i className="fas fa-info-circle"></i></Tooltip>,
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
            sorter: {
                compare: (a, b) =>Number(a.total_paid) - Number(b.total_paid),
                multiple: 1,
            },
        },
        {
            dataIndex: 'count_order_tv',
            title: <Tooltip className="show-tooltip" title='Tổng hoá đơn kỹ thuật viên tư vấn cho khách hàng. Chỉ nhận những đơn hàng đã bắt đầu thanh toán.'> Tổng hoá đơn <i className="fas fa-info-circle"></i></Tooltip>,
            width: 150 ,
            align: "center",
            render: (data) => {
                return (
                    <p className="text3">{data}</p>
                )
            },
        },
        {
            dataIndex: 'count_service',
            title: <Tooltip className="show-tooltip" title='Số dịch vụ tính theo hoá đơn. Ví dụ: Trong cùng một hoá đơn mua hàng khách mua hai dịch vụ thì số dịch vụ là hai.'> Số dịch vụ <i className="fas fa-info-circle"></i></Tooltip>,
            width: 150 ,
            align: "center",
            render: (data) => {
                return (
                    <p className="text3">{data}</p>
                )
            },
        },
        
        {
            dataIndex: 'aov',
            title: 'AOV',
            title: <Tooltip className="show-tooltip" title='Tỷ lệ sô tiền thực thu của kỹ thuật viên chia cho số đơn hàng kỹ thuật viên tư vấn được.'> AOV <i className="fas fa-info-circle"></i></Tooltip>,

            width: 150 ,
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
        },
        {
            title: 'Triệt lông',
            align: "start",
            render: (data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Thực thu: {convertCurrency(data.paidTriet)}</p>
                        <p className="text2">Tổng hoá đơn: {data.countTriet}</p>
                        <p className="text3">AOV: {convertCurrency(data.aovTriet)}</p>
                    </div>
                )
            },
        },
        {
            title: 'Da',
            align: "start",
            render: (t,data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Thực thu: {convertCurrency(data.paidDa)}</p>
                        <p className="text2">Tổng hoá đơn: {data.countDa}</p>
                        <p className="text3">AOV: {convertCurrency(data.aovDa)}</p>
                    </div>
                )
            },
        },
        {
            title: 'Chăm sóc body',
            align: "start",
            render: (data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Thực thu: {convertCurrency(data.paidBody)}</p>
                        <p className="text2">Tổng hoá đơn: {data.countBody}</p>
                        <p className="text3">AOV: {convertCurrency(data.aovBody)}</p>
                    </div>
                )
            },
        },
        {
            // dataIndex: 'countKhac',
            title: 'Đầu triệt',
            align: "start",
            render: (t,data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Thực thu: {convertCurrency(data.paidDauTriet)}</p>
                        <p className="text2">Tổng hoá đơn: {data.countDauTriet}</p>
                        <p className="text3">AOV: {convertCurrency(data.aovDauTriet)}</p>
                    </div>
                )
            },
        },
        {
            title: 'Mỹ phẩm',
            align: "start",
            render: (t,data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Thực thu: {convertCurrency(data.paidMyPham)}</p>
                        <p className="text2">Tổng hoá đơn: {data.countMyPham}</p>
                        <p className="text3">AOV: {convertCurrency(data.aovMyPham)}</p>
                    </div>
                )
            },
        },
        {
            title: 'Gội',
            align: "start",
            render: (t,data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Thực thu: {convertCurrency(data.paidGoi)}</p>
                        <p className="text2">Tổng hoá đơn: {data.countGoi}</p>
                        <p className="text3">AOV: {convertCurrency(data.aovGoi)}</p>
                    </div>
                )
            },
        },
    ];

    const handelExportUser = () => {

    }
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    return (
        <>
            <div style={{ backgroundColor: "white" }} className="p-2">
                
                <div className="border-bottom w-100 pb-2">
                    <Row>
                        <Col xs={6}>
                            <div>
                                Bảng số liệu chi tiết
                            </div>
                        </Col>
                        <Col xs={6}>
                            {/* <Button size="middle" type="primary"
                             onClick={handelExportUser}
                            ><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                            </Button> */}
                        </Col>
                    </Row>
                </div>
                    
                <Table 
                    columns={columns} 
                    dataSource={props.table}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                    // scroll={{ x: 'calc(700px + 50%)', y: 600 }}
                    scroll={{ x: columns.length*190, y: 600 }}
                    onChange={handleChange}
                    bordered
                />
            </div>
            <Loading
                show={showLoading}
            ></Loading>
        </>
    )
}
export default ReportKtvTvvDetailCat